import { Material } from './material';

export class MaterialPlanejamentoOficina {
    
	id: number;
	valorMaterial: number;
	dataAquisicao: Date;
	dataVendaMaterial: Date;
	
	descricaoOrigemMaterial: string;
	quantidadeMaterial: number;
	quantidadeMaterialVendida: number;
	formaPagamento: string;
	idPlanejamentoOficina: number;
	
	material: Material;
	usuarioAlteracao: number;
    
}
